import { OutlinedButton } from "../../../../../../components/OutlinedButton";
import { SolidButton } from "../../../../../../components/SolidButton";
import { i18n } from "../../../../../../localization/i18n";
import { Container, Footer } from "./styles";

interface GlobalTipWarningProps {
  closeModal: () => void;
  changeGlobalTips: () => void;
  loading: boolean;
}

export function GlobalTipWarning({
  closeModal,
  changeGlobalTips,
  loading,
}: GlobalTipWarningProps) {
  return (
    <Container>
      <div className="title">{`${i18n.t("tips.activateTip")}`}</div>
      <div className="description">{`${i18n.t("tips.globalWarning")}`}</div>

      <Footer>
        <OutlinedButton text={i18n.t("tips.cancel")} onClick={closeModal} />
        <SolidButton
          text={i18n.t("tips.confirm")}
          onClick={changeGlobalTips}
          loading={loading}
        />
      </Footer>
    </Container>
  );
}
